/* eslint-disable @typescript-eslint/no-explicit-any */
export class CustomError extends Error {
  public readonly errorCode: string;
  public readonly statusCode: number;
  public readonly error?: any;
  public readonly validation?: Array<{
    field: string;
    message: string;
    code: string;
  }>;

  constructor(
    message: string,
    errorCode: string,
    statusCode: number = 500,
    error?: any,
    validation?: Array<{
      field: string;
      message: string;
      code: string;
    }>
  ) {
    super(message);

    this.errorCode = errorCode;
    this.statusCode = statusCode;
    this.error = error;
    this.validation = validation;

    // Mantém o stack trace para debugging
    Error.captureStackTrace(this, this.constructor);
  }

  /**
   * Cria um erro a partir da resposta da API
   */
  static fromAPIResponse(
    apiResponse: {
      message: string;
      errorCode: string;
      error?: any;
      validation?: Array<{
        field: string;
        message: string;
        code: string;
      }>;
    },
    statusCode: number = 500
  ): CustomError {
    return new CustomError(
      apiResponse.message,
      apiResponse.errorCode,
      statusCode,
      apiResponse.error,
      apiResponse.validation
    );
  }
}
